import { languageOptions } from '@/constants';
import { useSetDefaultLanguageMutation } from '@/redux/api/api.caller';
import { ILanguageList } from '@/types/language';
import { Banner, BlockStack, Modal } from '@shopify/polaris';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleMutationResult } from '../../toastResult';
import LanguageAutocomplete from '../LanguageAutocomplete';

interface Props {
  open: boolean;
  onClose: () => void;
  list: ILanguageList;
}

const SetDefaultModal = ({ open, onClose, list }: Props) => {
  const dispatch = useDispatch();
  const [setDefaultLanguage, { isLoading }] = useSetDefaultLanguageMutation();
  const options = languageOptions.filter((o) => o.value !== list.defaultLanguage);
  const [selected, setSelected] = useState<string>('');

  const onSubmit = () => {
    if (!selected) return;
    setDefaultLanguage({ language: selected }).then((res: any) => {
      if (handleMutationResult(dispatch, res)) {
        setSelected('');
        onClose();
      }
    });
  };

  return (
    <Modal
      open={open}
      title="Change default language"
      onClose={onClose}
      primaryAction={{ content: 'Set as default', onAction: onSubmit, loading: isLoading, disabled: !selected }}
      secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
    >
      <Modal.Section>
        <BlockStack gap="400">
          <Banner tone="warning">
            If you pick a language that isn't in your published list, it'll be added automatically with pre-translated text.
            The previous default becomes a regular published language you can translate separately.
          </Banner>
          <LanguageAutocomplete label="New default language" options={options} selected={selected} onChange={setSelected} />
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};

export default SetDefaultModal;
